// `JSON.stringify` doesn't escape `<`, so embedding it directly in a `<script>` tag lets a
// value like `</script><script>...` in the payload break out of the JSON-LD block and inject
// arbitrary markup. `<` is a valid JSON escape that JSON.parse resolves back to `<`,
// so this changes nothing about the parsed data — only how it's serialized into HTML.
export const toSafeJsonLdString = (value: unknown): string =>
    JSON.stringify(value).replace(/</g, "\\u003c");
